import NativeSmoothScroll from '@/js/components/smooth-scroll'
import Search from '@/js/components/search'
import Accordion from '@/js/components/accordion'
import Navigation from '@/js/components/navigation'
import SidebarShowMore from '@/js/components/sidebar-show-more'
import BackToTop from '@/js/components/back-to-top'
import AjaxTabs from '@/js/components/ajax-tabs'
import Pagination from '@/js/components/ajax-pagination'
import CopyShareText from '@/js/components/share'
import PageProgressBar from '@/js/components/page-progress-bar'
import DarkMode from '@/js/components/dark-mode'
import smoothscroll from 'smoothscroll-polyfill'

const accordion = Array.from(document.querySelectorAll('.js-accordion'))
const search = Array.from(document.querySelectorAll('.js-search'))
const sidebarShowMore = Array.from(document.querySelectorAll('.js-read-more'))
const tabsHolder = Array.from(document.querySelectorAll('.js-tabs'))
const pagination = Array.from(document.querySelectorAll('.js-pagination'))
const sharesHolder = Array.from(document.querySelectorAll('.js-copy-share-text'))
const progressBars = Array.from(document.querySelectorAll('.js-page-progress-bar'))
const switchTarget = Array.from(document.querySelectorAll('.js-switch'))

smoothscroll.polyfill()
sidebarShowMore.map(element => new SidebarShowMore(element))
search.map(element => new Search(element))
accordion.map(element => new Accordion(element))
tabsHolder.map(element => new AjaxTabs(element))
pagination.map(element => new Pagination(element))
sharesHolder.map(element => new CopyShareText(element))
progressBars.map(element => new PageProgressBar(element))
switchTarget.map(element => new DarkMode(element))
// required to get entry point for sass compilations in webpack
require('../scss/main.scss')

new Navigation('.js-menu')
new NativeSmoothScroll()
new BackToTop('.back-to-top')
